import { Route, Routes } from "react-router-dom";
import ClientsPage from "../../../../pages/module-pages/support/clients/ClientsPage";
import ClientDetailsPage from "../../../../pages/module-pages/support/clients/ClientDetailsPage";

export default function ClientNav() {
  return (
    <Routes>
      <Route path="/" element={<ClientsPage />} />
      <Route path="/details" element={<ClientDetailsPage />} />
    </Routes>
  );
}
